"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisticVideoLearningStatus = exports.updateCacheOnVideoLearningStatusUpdate = exports.UPSERT_USER_VIDEO_STATUS = exports.optimisticStationLearningStatus = exports.updateCacheOnStationLearningStatusUpdate = exports.UPSERT_USER_STATION_STATUS = exports.optimisticConceptLearningStatus = exports.updateCacheOnConceptLearningStatusUpdate = exports.UPSERT_USER_CONCEPT_STATUS = exports.TOC_ACCEPT = exports.RENEW_TOKEN = exports.updateCacheOnUpdateUserSettings = exports.optimisticUpdateUserSettings = exports.optimisticAddProductFeedback = exports.ADD_PRODUCT_FEEDBACK = exports.UPDATE_USER_SETTINGS = exports.UPDATE_USER = exports.DELETE_USER = exports.RESET_CATEGORY_PROGRESS = exports.RESET_PROGRESS = exports.LOGOUT_USER = void 0;
const client_1 = require("@apollo/client");
const models_1 = require("../../../models");
const utils_1 = require("../../../utils");
const fragments_1 = require("../../fragments");
exports.LOGOUT_USER = (0, client_1.gql) `
  mutation LogoutUser($all: Boolean!) {
    restricted {
      logoutUser(all: $all)
    }
  }
`;
exports.RESET_PROGRESS = (0, client_1.gql) `
  mutation ResetProgress($questions: Boolean, $cards: Boolean) {
    restricted {
      resetProgress(questions: $questions, cards: $cards) {
        id
      }
    }
  }
`;
exports.RESET_CATEGORY_PROGRESS = (0, client_1.gql) `
  mutation ResetCategoryProgress(
    $topicIds: [Int!]
    $conceptIds: [Int!]
    $stationIds: [Int!]
  ) {
    restricted {
      resetCategoryProgress(
        topicIds: $topicIds
        conceptIds: $conceptIds
        stationIds: $stationIds
      )
    }
  }
`;
exports.DELETE_USER = (0, client_1.gql) `
  mutation DeleteUser {
    restricted {
      deleteUser
    }
  }
`;
exports.UPDATE_USER = (0, client_1.gql) `
  mutation UpdateUser($id: Int, $data: UserInput!) {
    restricted {
      updateUser(id: $id, data: $data) {
        jwt
        user {
          id
          displayName
          username
          firstName
          lastName
          classYear
          graduationYear
          universityId
          tocAccepted
        }
      }
    }
  }
`;
exports.UPDATE_USER_SETTINGS = (0, client_1.gql) `
  ${fragments_1.USER_SETTINGS_FIELDS}
  mutation UpdateUserSettings($input: UserSettingsInput!) {
    restricted {
      updateUserSettings(input: $input) {
        ...UserSettingsFields
      }
    }
  }
`;
exports.ADD_PRODUCT_FEEDBACK = (0, client_1.gql) `
  mutation AddProductFeedback($rating: Int, $feedback: String) {
    restricted {
      addProductFeedback(rating: $rating, feedback: $feedback) {
        id
        userId
        createdAt
        rating
        feedback
        productId
      }
    }
  }
`;
const optimisticAddProductFeedback = (input) => ({
    restricted: {
        addProductFeedback: {
            rating: input.rating || null,
            feedback: input.feedback || null,
            createdAt: new Date(),
            userId: 1,
            productId: models_1.EProductType.QBANK,
            id: (0, utils_1.randomInt)(),
            product: {
                id: models_1.EProductType.QBANK,
                index: 0,
                name: models_1.EProductType[models_1.EProductType.QBANK],
            },
        },
    },
});
exports.optimisticAddProductFeedback = optimisticAddProductFeedback;
const optimisticUpdateUserSettings = (settings) => ({ input }) => ({
    restricted: {
        updateUserSettings: {
            __typename: 'UserSettings',
            ...settings,
            updatedAt: new Date(),
            globalSettings: {
                ...settings.globalSettings,
                ...input.globalSettings,
            },
            productSettings: {
                ...settings.productSettings,
                ...input.productSettings,
            },
        },
    },
});
exports.optimisticUpdateUserSettings = optimisticUpdateUserSettings;
const updateCacheOnUpdateUserSettings = (cache, result, options) => {
    const { updateUserSettings } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !updateUserSettings) {
        return;
    }
    cache.writeFragment({
        id: cache.identify({
            id: updateUserSettings.userId,
            __typename: 'User',
        }),
        data: {
            settings: {
                ...updateUserSettings,
                nextFeedbackDate: new Date(Date.now() + 6.048e8), // + 1 week
            },
        },
        fragment: fragments_1.UPDATE_USER_SETTINGS_FRAGMENT,
        fragmentName: 'UpdateUserSettingsFragment',
    });
};
exports.updateCacheOnUpdateUserSettings = updateCacheOnUpdateUserSettings;
exports.RENEW_TOKEN = (0, client_1.gql) `
  mutation RenewToken {
    restricted {
      renewToken
    }
  }
`;
exports.TOC_ACCEPT = (0, client_1.gql) `
  mutation TocAccept {
    restricted {
      tocAccept
    }
  }
`;
exports.UPSERT_USER_CONCEPT_STATUS = (0, client_1.gql) `
  mutation UpsertUserConceptStatus($conceptIds: [Int!]!, $status: Int!) {
    restricted {
      upsertUserConceptStatus(conceptIds: $conceptIds, status: $status) {
        id
        status
        conceptId
        userId
        createdAt
      }
    }
  }
`;
const STATUS_CONCEPT_FRAGMENT = (0, client_1.gql) `
  fragment ConceptStatus on Concept {
    status
  }
`;
const TOPIC_CONCEPT_STATUS_STATS_FRAGMENT = (0, client_1.gql) `
  fragment TopicConceptStatusStats on Topic {
    unreadConcepts
    completedConcepts
    revisingConcepts
    urgentConcepts
  }
`;
const getConceptStatsFieldName = (status) => {
    switch (status) {
        case models_1.EUserLearningStatus.URGENT:
            return 'urgentConcepts';
        case models_1.EUserLearningStatus.REVISING:
            return 'revisingConcepts';
        case models_1.EUserLearningStatus.COMPLETED:
            return 'completedConcepts';
        case models_1.EUserLearningStatus.UNREAD:
        default:
            return 'unreadConcepts';
    }
};
const getConceptUpdatedFieldNames = (newStatus, prevStatus) => [
    getConceptStatsFieldName(prevStatus),
    getConceptStatsFieldName(newStatus),
];
const updateCacheOnConceptLearningStatusUpdate = (topicId, prevStatus) => (cache, result, options) => {
    const { upsertUserConceptStatus } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !upsertUserConceptStatus) {
        return;
    }
    const { conceptIds, status } = variables;
    conceptIds.forEach((id) => {
        cache.writeFragment({
            id: cache.identify({ id, __typename: 'Concept' }),
            data: {
                status,
            },
            fragment: STATUS_CONCEPT_FRAGMENT,
        });
    });
    const prevData = cache.readFragment({
        id: cache.identify({
            id: topicId,
            __typename: 'Topic',
        }),
        fragment: TOPIC_CONCEPT_STATUS_STATS_FRAGMENT,
    });
    if (prevData) {
        const [prevStatName, newStatName] = getConceptUpdatedFieldNames(status, prevStatus);
        const newData = {
            ...prevData,
            [newStatName]: (prevData[newStatName] || 0) + conceptIds.length,
        };
        if (prevStatus !== undefined &&
            prevStatus !== null &&
            prevData[prevStatName]) {
            newData[prevStatName] =
                (prevData[prevStatName] || 0) - conceptIds.length;
        }
        cache.writeFragment({
            id: cache.identify({ id: topicId, __typename: 'Topic' }),
            data: {
                ...newData,
            },
            fragment: TOPIC_CONCEPT_STATUS_STATS_FRAGMENT,
        });
    }
};
exports.updateCacheOnConceptLearningStatusUpdate = updateCacheOnConceptLearningStatusUpdate;
const optimisticConceptLearningStatus = (id, conceptIds, userId, status) => {
    const response = {
        userId,
        status,
    };
    return {
        restricted: {
            upsertUserConceptStatus: conceptIds.map((conceptId) => ({
                __typename: 'UserConceptStatus',
                ...response,
                createdAt: new Date(),
                id,
                conceptId,
            })),
        },
    };
};
exports.optimisticConceptLearningStatus = optimisticConceptLearningStatus;
exports.UPSERT_USER_STATION_STATUS = (0, client_1.gql) `
  mutation UpsertUserStationStatus($osceStationIds: [Int!]!, $status: Int!) {
    restricted {
      upsertUserStationStatus(
        osceStationIds: $osceStationIds
        status: $status
      ) {
        id
        status
        osceStationId
        userId
        createdAt
      }
    }
  }
`;
const STATION_CONCEPT_FRAGMENT = (0, client_1.gql) `
  fragment StationStatus on OsceStation {
    status
  }
`;
const updateCacheOnStationLearningStatusUpdate = (cache, result, options) => {
    const { upsertUserStationStatus } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !upsertUserStationStatus) {
        return;
    }
    const { osceStationIds, status } = variables;
    osceStationIds.forEach((id) => {
        cache.writeFragment({
            id: cache.identify({ id, __typename: 'OsceStation' }),
            data: {
                status,
            },
            fragment: STATION_CONCEPT_FRAGMENT,
        });
    });
};
exports.updateCacheOnStationLearningStatusUpdate = updateCacheOnStationLearningStatusUpdate;
const optimisticStationLearningStatus = (id, osceStationIds, userId, status) => {
    const response = {
        userId,
        status,
    };
    return {
        restricted: {
            upsertUserStationStatus: osceStationIds.map((osceStationId) => ({
                __typename: 'UserStationStatus',
                ...response,
                createdAt: new Date(),
                id,
                osceStationId,
            })),
        },
    };
};
exports.optimisticStationLearningStatus = optimisticStationLearningStatus;
exports.UPSERT_USER_VIDEO_STATUS = (0, client_1.gql) `
  mutation UpsertUserVideoStatus($videoIds: [Int!]!, $status: Int!) {
    restricted {
      upsertUserVideoStatus(videoIds: $videoIds, status: $status) {
        id
        status
        videoId
        video {
          concepts {
            id
            topicId
          }
          osceStation {
            id
            name
            osceTypeId
          }
        }
        userId
        createdAt
      }
    }
  }
`;
const VIDEO_STATUS_FRAGMENT = (0, client_1.gql) `
  fragment VideoStatus on Video {
    status
  }
`;
const TOPIC_VIDEO_STATUS_STATS_FRAGMENT = (0, client_1.gql) `
  fragment TopicVideoStatusStats on Topic {
    unwatchedVideos
    completedVideos
    revisingVideos
    urgentVideos
  }
`;
const getVideoStatsFieldName = (status) => {
    switch (status) {
        case models_1.EUserLearningStatus.URGENT:
            return 'urgentVideos';
        case models_1.EUserLearningStatus.REVISING:
            return 'revisingVideos';
        case models_1.EUserLearningStatus.COMPLETED:
            return 'completedVideos';
        case models_1.EUserLearningStatus.UNREAD:
        default:
            return 'unwatchedVideos';
    }
};
const getVideoUpdatedFieldNames = (newStatus, prevStatus) => [
    getVideoStatsFieldName(prevStatus),
    getVideoStatsFieldName(newStatus),
];
const updateCacheOnVideoLearningStatusUpdate = (prevStatus) => (cache, result, options) => {
    const { upsertUserVideoStatus } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !upsertUserVideoStatus) {
        return;
    }
    const { videoIds, status } = variables;
    videoIds.forEach((id) => {
        cache.writeFragment({
            id: cache.identify({ id, __typename: 'Video' }),
            data: {
                status,
            },
            fragment: VIDEO_STATUS_FRAGMENT,
        });
    });
    const topicIds = new Set();
    upsertUserVideoStatus.forEach(({ video }) => {
        const { concepts } = video;
        if (concepts) {
            concepts.forEach(({ topicId }) => {
                topicIds.add(Number(topicId));
            });
        }
    });
    if (!topicIds.size) {
        return;
    }
    [...topicIds].forEach((topicId) => {
        const prevData = cache.readFragment({
            id: cache.identify({
                id: topicId,
                __typename: 'Topic',
            }),
            fragment: TOPIC_VIDEO_STATUS_STATS_FRAGMENT,
        });
        if (prevData) {
            const [prevStatName, newStatName] = getVideoUpdatedFieldNames(status, prevStatus);
            const newData = {
                ...prevData,
                [newStatName]: (prevData[newStatName] || 0) + videoIds.length,
            };
            if (prevStatus !== undefined &&
                prevStatus !== null &&
                prevData[prevStatName]) {
                newData[prevStatName] =
                    (prevData[prevStatName] || 0) - videoIds.length;
            }
            cache.writeFragment({
                id: cache.identify({ id: topicId, __typename: 'Topic' }),
                data: {
                    ...newData,
                },
                fragment: TOPIC_VIDEO_STATUS_STATS_FRAGMENT,
            });
        }
    });
};
exports.updateCacheOnVideoLearningStatusUpdate = updateCacheOnVideoLearningStatusUpdate;
const optimisticVideoLearningStatus = (id, videoIds, userId, status) => {
    const response = {
        userId,
        status,
    };
    // The video field is needed to updated not only the video status but related topics stats.
    // We are not able to get this data for optimisitc response, as we don't have all videos
    // with all their concepts in the cache, but we pass an empty object to let updae function works
    // with no errors. In the case of offline mode the status of updated video on the video list
    // or the status on the video view will be updated in the cahce and UI will be updated
    return {
        restricted: {
            upsertUserVideoStatus: videoIds.map((videoId) => ({
                __typename: 'UserVideoStatus',
                ...response,
                id,
                createdAt: new Date(),
                videoId,
                video: {},
            })),
        },
    };
};
exports.optimisticVideoLearningStatus = optimisticVideoLearningStatus;
